import type { PageWithLayout, PageProps } from "@types";
import type { Meta } from "@layouts/page";
import type { GetServerSideProps } from "next";

import Page from "@layouts/page";
import { setContext } from "@utils/Cookies";
import { getLayout as getDefaultLayout } from "@layouts/default-layout";
import SearchView from "@modules/layout/searchView";

interface Props extends PageProps {}

const SearchPage: PageWithLayout<Props> = ({ appFallback }) => {
  const meta: Meta = {
    title: "Search Page",
    description: appFallback?.website.description || "Dabdoob",
    keywords: appFallback?.website.keywords,
  };

  return (
    <Page meta={meta}>
      <SearchView />
    </Page>
  );
};

SearchPage.translationFile = "translation";
SearchPage.getLayout = (page, props) => getDefaultLayout(page, { ...props }, {});

export const getServerSideProps: GetServerSideProps<Props> = async (ctx) => {
  //Hussein: Very important to set the context here to transfer auth token and locale info from client browser cookies to server
  setContext(ctx);
  return {
    props: {},
  };
};

export default SearchPage;
